<template>
<div class="background">
  <div class="top">
    <div class="top-center">
      <span style="    white-space: nowrap;"> 多媒体馆藏发布中心</span>
    </div>
    <div class="top-center collection" style="flex:3; justify-content: center;">
      <el-button class="btn-focus" size="default" disabled>上传</el-button>
      <span style="padding:5px;color:#999999;font-size:14px;"> ··· </span>
      <el-button :class="status>=1?'btn-focus':'btn-dis'" size="default" disabled>AI审核</el-button>
      <span style="padding:5px;color:#999999;font-size:14px;"> ··· </span>
      <el-button :class="status>=2?'btn-focus':'btn-dis'" size="default" disabled>转码</el-button>
      <span style="padding:5px;color:#999999;font-size:14px;"> ··· </span>
      <el-button :class="status>=3?'btn-focus':'btn-dis'" size="default" disabled>著录</el-button>
      <span style="padding:5px;color:#999999;font-size:14px;"> ··· </span>
      <el-button :class="status>=4?'btn-focus':'btn-dis'" size="default" disabled>AI审核</el-button>
      <span style="padding:5px;color:#999999;font-size:14px;"> ··· </span>
      <el-button class="btn-dis" size="default" disabled>人工审核</el-button>
      <span style="padding:5px;color:#999999;font-size:14px;"> ··· </span>
      <el-button class="btn-dis" size="default" disabled>审核</el-button>
      <span style="padding:5px;color:#999999;font-size:14px;"> ··· </span>
      <el-button class="btn-dis" size="default" disabled>存储</el-button>
      <span style="padding:5px;color:#999999;font-size:14px;"> ··· </span>
      <el-button class="btn-dis" size="default" disabled>入藏</el-button>
    </div>
    <div style="flex:1">
      <!-- href="" target="_blank" -->
      <el-link style="float:right;margin-right:20px" class="top-right" type="primary" :underline="false">操作说明</el-link>
    </div>

  </div>
  <div style="  background-color: #f3f4f9;">

    <upload v-if="status == 0" :nextStatus="getNextStatus(0)" @uploadNext="uploadNext" />
    <ai-examine v-else-if="status == 1" :nextStatus="getNextStatus(1)" @uploadNext="uploadNext" />
    <transcoding v-else-if="status == 2" :nextStatus="getNextStatus(2)" @uploadNext="transcodingNext" />
    <description v-else-if="status == 3" :nextStatus="getNextStatus(3)" @uploadNext="uploadNext" />
    <ai-chronicle v-else-if="status == 4" :nextStatus="getNextStatus(4)" @uploadNext="uploadNext" />
    <result @uploadNext="repeatUpload" v-else />
  </div>
</div>
</template>

<script>
import AiChronicle from './components/aiChronicle.vue'
import AiExamine from './components/aiExamine.vue'
import Description from './components/description.vue'
import Result from './components/result.vue'
import Transcoding from './components/transcoding.vue'

import upload from './components/upload.vue'
import {

  collectionResource
} from '@/api/library'
export default {
  name: 'Single',
  components: {
    upload,
    AiExamine,
    Transcoding,
    Description,
    AiChronicle,
    Result
  },
  data() {
    return {
      status: 0,

      // 0-创建 1-文件AI审核 2-转码 3-著录 4-著录AI 5-团队审核 6-审校 7-存储转码 8-发布)
      statusList: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      listTend: {
        ADKS: [0, 1, 2, 3, 4, 5, 6],
        CQU: [0, 1, 2, 3, 4, 5, 6],
      },
      tenantId: this.$store.getters.tenantId,
       //
      clinetUploadFlow:this.$store.getters.application.clinetUploadFlow
    }
  },
  mounted() {

    this.uploadNext()
     let that =this;
      setTimeout(() => {
          that.clinetUploadFlow =this.$store.getters.application.clinetUploadFlow
    }, 500); 
  },
  // status状态(0-创建 1-文件AI审核 2-转码 3-著录 4-著录AI 5-团队审核 6-审校 7-存储转码 8-发布)
  methods: {
    getNextStatus(status) {
        let tenantIpClient = this.clinetUploadFlow;
        let listTend = [];
        console.log('tenantIpClient',tenantIpClient)
        if(tenantIpClient){
        // 把租户的上传流程转成数组
            let arr= tenantIpClient.split(',');
            arr.forEach(element => {
                listTend.push(Number(element))
            });
        }
        console.log('listTendlistTend',listTend)
        if (listTend) {
            return listTend.find(element => {
            return element > status
            })
        } else {
            return (status + 1)
        }
    },
    // getNextStatus(status) {
    //   let application = this.$store.getters.application;
    //   let listTenant = application.clinetUploadFlow;
    
    //   // listTenant = listTenant.replace(';',' ')
    //   console.log('listTenantttttttttt',listTenant)
    //   if (this.listTend[this.tenantId]) {

    //     return this.listTend[this.tenantId].find(element => {
    //       return element > status
    //     })
    //   } else {
    //     return (status + 1)
    //   }
      

    // },
    async collectionResource() {
      const res = await collectionResource({
        ids: this.$route.query.collectionId
      })
      if (res.data) {
        this.status = res.data[0].status
      } else {
        this.status = 0
        this.$router.push({
          path: '/single',
          query: {
            collectionId: 0
          }
        })
      }
    },
    repeatUpload() {
      this.$router.push({
        path: '/single',
        query: {
          collectionId: 0,
        }
      })
      this.status = 0

    },
    transcodingNext() {
      this.status = 3
    },
    uploadNext() {
      if (this.$route.query.collectionId && this.$route.query.collectionId != 0) {
        this.collectionResource()

      } else {
        this.status = 0
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.background {
  background-color: #f3f4f9;
  height: 100%;
}

.collection {
  ::v-deep .el-button {

    padding: 0px 10px;
    font-size: 12px;
  }
}

::v-deep .el-cascader {

  width: 100%;

}

.btn-focus {

  height: 24px;
  background: #1F233E !important;
  border-radius: 5px;

  color: #FFFFFF;

  height: 24px;
}

.btn-dis {

  color: #7B84A1;

  height: 24px;
  background: #F3F4F9 !important;
  border-radius: 5px;
}

.top {

  display: flex;
  flex-direction: row;
  height: 50px;
  left: 0;
  right: 0;
  top: 0;
  position: fixed;
  z-index: 100;
  background-color: #fff;
  justify-content: space-between;

  &-center {
    display: flex;
    align-items: center;

    flex: 1;
    font-size: 20px;
    margin-left: 20px;
    line-height: 50px;
    font-weight: bold;

    color: #1F233E;
  }

  &-right {
    flex: 1;
    font-size: 12px;
    line-height: 50px;
    color: #7B84A1;
  }
}
</style>
